import React, { Component } from "react";
import PropTypes from "prop-types";
import styled from "styled-components";
import { Box } from "@material-ui/core";
import Dialog from "../../../waybee-ui/Dialog/Dialog";
import DialogTitle from "../../../waybee-ui/Dialog/DialogTitle";
import DialogContent from "../../../waybee-ui/Dialog/DialogContent";
import Loading from "../../../components/Loading";

const IframeContainer = styled.div`
  width: 100%;
  height: 100%;
  overflow: hidden;
  position: relative;
`;

const StyledIframe = styled.iframe`
  opacity: ${props => (props.isLoading ? 0 : 1)};
  transition: opacity 0.3s;
  width: 100%;
  height: calc(100% + 60px);
  border: none;
`;

const LoadingOverlay = styled.div`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 1000;
  background-color: white;
  padding: 20px;
`;

class ConversationReportDialog extends Component {
  state = {
    isIframeLoading: true
  };

  componentDidUpdate(prevProps) {
    const { open, reportsDashboard } = this.props;
    // Reset loading state when dialog opens or reportsDashboard changes
    if (
      (open && !prevProps.open) ||
      reportsDashboard !== prevProps.reportsDashboard
    ) {
      // Use setTimeout to avoid setState in componentDidUpdate
      setTimeout(() => {
        this.setState({ isIframeLoading: true });
      }, 0);
    }
  }

  handleIframeLoad = () => {
    this.setState({ isIframeLoading: false });
  };

  render() {
    const { isIframeLoading } = this.state;
    const { open, onClose, loading, reportsDashboard } = this.props;

    return (
      <Dialog open={open} onClose={onClose} fullWidth maxWidth="lg" closeButton>
        <DialogTitle>Relatório da Conversa</DialogTitle>
        <DialogContent>
          {loading ? (
            <Box py={4} display="flex" justifyContent="center">
              <Loading />
            </Box>
          ) : (
            <Box py={2} position="relative" height="600px" minHeight="600px">
              {reportsDashboard && (
                <IframeContainer>
                  <StyledIframe
                    title="Metabase - Relatório da Conversa"
                    src={reportsDashboard}
                    frameBorder={0}
                    allowTransparency
                    onLoad={this.handleIframeLoad}
                    isLoading={isIframeLoading}
                  />
                </IframeContainer>
              )}
              {isIframeLoading && reportsDashboard && (
                <LoadingOverlay>
                  <Loading />
                </LoadingOverlay>
              )}
              {!reportsDashboard && (
                <Box p={2} textAlign="center">
                  Relatório não disponível para esta conversa.
                </Box>
              )}
            </Box>
          )}
        </DialogContent>
      </Dialog>
    );
  }
}

ConversationReportDialog.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  loading: PropTypes.bool,
  reportsDashboard: PropTypes.string
};

ConversationReportDialog.defaultProps = {
  loading: false,
  reportsDashboard: null
};

export default ConversationReportDialog;
